/**
 * @generated SignedSource<<304a92793a059596f7ca03b92a73e27a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttachmentTypeInput = {
  document_id?: string | null | undefined;
  file?: AttachmentFileTypeInput | null | undefined;
  model_id: string;
  model_type: string;
  new_order?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type AttachmentFileTypeInput = {
  base64?: string | null | undefined;
  mime_type?: string | null | undefined;
  name?: string | null | undefined;
};
export type DeleteAttachmentMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AttachmentTypeInput;
};
export type DeleteAttachmentMutation$data = {
  readonly deleteAttachment: string | null | undefined;
};
export type DeleteAttachmentMutation = {
  response: DeleteAttachmentMutation$data;
  variables: DeleteAttachmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "deleteAttachment",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteAttachmentMutation",
    "selections": [
      (v3/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteAttachmentMutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteAttachment",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0b2b34a5baf92d1733e6b75b3d248208",
    "id": null,
    "metadata": {},
    "name": "DeleteAttachmentMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteAttachmentMutation(\n  $input: AttachmentTypeInput!\n) {\n  deleteAttachment(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "731cdfda75b13e8e8b247eaad7b4515e";

export default node;
